import React from "react";


const FooterCard14 = () => {
  return (<>
    <footer className="eo-footer">

      {/* Curved Top Shape */}
      <div className="eo-wave"></div>

      <div className="eo-container">

        {/* Column 1 */}
        <div className="eo-col">
          <h2 className="eo-logo">Executive Oasis</h2>

          <p className="eo-text">
            123 Fairway Lane Golftown, Golfshire  
            56789 United States
          </p>

          <p className="eo-text">
            <strong>Phone:</strong> +1 (555) 123-4567
          </p>
        </div>

        {/* Column 2 */}
        <div className="eo-col">
          <h3>Quick Links</h3>
          <ul>
            <li>About Us</li>
            <li>Blog</li>
            <li>Gallery</li>
            <li>Services</li>
          </ul>
        </div>

        {/* Column 3 */}
        <div className="eo-col">
          <h3>Contact Us</h3>
          <ul>
            <li>Contact Us</li>
            <li>FAQs</li>
            <li className="eo-btn">Buy Now</li>
          </ul>
        </div>

        {/* Column 4 */}
        <div className="eo-col">
          <h3>Legal Information</h3>
          <ul>
            <li>Privacy Policy</li>
            <li>Terms & Conditions</li>
            <li>Refund Policy</li>
          </ul>
        </div>

      </div>

      <div className="eo-bottom">
        © 2025 Executive Oasis — All Rights Reserved.
      </div>
    </footer>
    <style>{`/* --- Footer Base --- */
.eo-footer {margin-top:50px;
  background: linear-gradient(135deg, #1a1d22 0%, #131518 100%);
  color: #e4e4e4;
  padding-top: 120px;
  position: relative;
  overflow: hidden;
  font-family: "Poppins", sans-serif;
}

/* --- Frosted Glass Wave --- */
.eo-wave {
  position: absolute;
  top: -90px;
  left: 0;
  right: 0;
  height: 180px;

  /* glass gradient */
  background: rgba(255, 255, 255, 0.02);

  border-bottom-left-radius: 60% 80px;
  border-bottom-right-radius: 60% 80px;

}

/* --- Glass Panel Container --- */
.eo-container {
  width: 85%;
  max-width: 1250px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 60px;

  padding: 50px 40px;
  border-radius: 18px;

  background: rgba(255, 255, 255, 0.04);
 

  box-shadow: 0 8px 28px rgba(0,0,0,0.45);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

/* --- Logo --- */
.eo-logo {
  font-size: 26px;
  margin-bottom: 18px;
  font-weight: 600;
  color: rgba(144, 202, 249,1);
  letter-spacing: 0.5px;
}

/* --- Headings --- */
.eo-col h3 {
  margin-bottom: 12px;
  font-size: 18px;
  color: rgba(144, 202, 249,1);
  font-weight: 600;
}

/* --- Text --- */
.eo-text {
  margin: 10px 0;
  line-height: 1.6;
  color: rgba(255,255,255,0.75);
}

/* --- List --- */
.eo-col ul {
  padding: 0;
  list-style: none;
}

.eo-col ul li {
  margin: 8px 0;
  cursor: pointer;
  transition: 0.25s ease;
  color: rgba(255,255,255,0.8);
}

.eo-col ul li:hover {
  color: rgba(144, 202, 249,1);
  transform: translateX(4px);
}

/* --- Buy Now Button --- */
.eo-btn {
  padding: 8px 16px;
  background: rgba(144, 202, 249,1);
  color: #1c1c1c !important;
  width: fit-content;
  border-radius: 8px;
  margin-top: 12px;
  font-weight: 600;
  transition: 0.3s;
}

.eo-btn:hover {
  background: rgba(144, 202, 249,1);
  transform: translateY(-2px);
}

/* --- Bottom Bar --- */
.eo-bottom {
  text-align: center;
  padding: 22px 0;
  margin-top: 40px;
  font-size: 14px;
  color: rgba(255,255,255,0.55);

  border-top: 1px solid rgba(255,255,255,0.15);
  
  backdrop-filter: blur(10px);
  background: rgba(255,255,255,0.03);
}

/* --- Responsive --- */
@media (max-width: 900px) {
  .eo-container {
    grid-template-columns: 1fr 1fr;
    padding: 40px 25px;
  }
}

@media (max-width: 600px) {
  .eo-container {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .eo-btn {
    margin: auto;
  }
}

`}</style>
  </>);
};

export default FooterCard14;
